import React from "react";
import { Redirect, useParams } from "react-router-dom";

import useFeatureFlags from "../hooks/useFeatureFlag";

export function WebTrackerDetailsPageRedirect() {
  const { trackerId } = useParams<{ trackerId: string }>();
  const flags = useFeatureFlags();

  // Probably not actually necessary, because this redirect should only be rendered in the first place if the feature
  // flag is enabled, but this should help safeguard against any future changes that might cause this to be rendered
  // when the unified destinations UI is not enabled.
  return flags("unifiedDestinationsUI") ? (
    <Redirect to={`/monitoring/trackingTools/${trackerId}`} />
  ) : null;
}
